/**
 * Tailwind classes: show panel on mobile when tab active; always show on lg+.
 * @param {string} mobileTab
 * @param {string} panelId
 */
export function mobilePanelClass(mobileTab, panelId) {
  const active = mobileTab === panelId;
  return [
    'min-h-0',
    active ? 'flex flex-1 flex-col' : 'hidden',
    'lg:flex lg:flex-col',
    panelId === 'configure' ? 'lg:shrink-0 lg:w-80' : '',
    panelId === 'embed' ? 'lg:shrink-0 lg:w-96' : '',
    panelId === 'preview' ? 'lg:flex-1 lg:min-w-0' : '',
  ].join(' ');
}
